import TCompanyAdd from './index.vue';

TCompanyAdd.install = app => {
  app.component(TCompanyAdd.name, TCompanyAdd);
};

export default TCompanyAdd;
